<template>
  <div class="page-container">
    <!-- 搜索区域 Card -->
    <a-card title="订单查询" :bordered="false" class="search-card">
      <a-form layout="inline">
        <a-form-item label="客户编码">
          <a-input v-model="queryParam.customNo" placeholder="请输入客户编码"/>
        </a-form-item>
        <a-form-item label="标签单号">
          <a-input v-model="queryParam.equickWBNo" placeholder="请输入标签单号"/>
        </a-form-item>
        <a-form-item label="运单号">
          <a-input v-model="queryParam.lableNo" placeholder="请输入运单号"/>
        </a-form-item>
        <a-form-item label="护照号">
          <a-input v-model="queryParam.consigneeIdCard" placeholder="请输入护照号"/>
        </a-form-item>
        <a-form-item label="订单状态">
          <a-select v-model="queryParam.orderStatus" style="width: 120px" placeholder="请选择">
            <a-select-option :value="undefined">全部</a-select-option>
            <a-select-option :value="0">运输中</a-select-option>
            <a-select-option :value="1">待取件</a-select-option>
            <a-select-option :value="2">已签收</a-select-option>
            <a-select-option :value="3">异常</a-select-option>
            <a-select-option :value="4">已取消</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="下单时间">
          <a-range-picker v-model="queryParam.orderTime"
                          :show-time="{ format: 'HH:mm',defaultValue: [$moment('00:00:00', 'HH:mm:ss'), $moment('23:59:59', 'HH:mm:ss')] }"
                          format="YYYY-MM-DD HH:mm:ss"
                          :placeholder="[$t('antd.table.startTime'), $t('antd.table.endTime')]"
                          @change="onDateChange" @ok="onDateOk"/>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="handleSearch">查询</a-button>
          <a-button style="margin-left: 8px" @click="handleReset">重置</a-button>
        </a-form-item>
      </a-form>
    </a-card>
<!--    统计区域-->
    <!-- 统计区域 -->
    <div class="statistics-container">
      <div class="statistics-content">
        <div class="statistic-item">
          <span class="statistic-label">{{ $t('dashboard.order.totalAmount') }}:</span>
          <span class="statistic-value">{{ statistics.payableTotal }}</span>
          <span class="statistic-unit">UZS</span>
        </div>
        <div class="statistic-item">
          <span class="statistic-label">{{ $t('dashboard.order.totalPayAmount') }}:</span>
          <span class="statistic-value">{{ statistics.payTotal }}</span>
          <span class="statistic-unit">UZS</span>
        </div>
        <div class="statistic-item">
          <span class="statistic-label">{{ $t('dashboard.order.totalDiscountAmount') }}:</span>
          <span class="statistic-value">{{ statistics.discountTotal }}</span>
          <span class="statistic-unit">UZS</span>
        </div>
      </div>
    </div>
    <!-- 表格区域 Card -->
    <a-card title="订单列表" :bordered="false" class="table-card">
      <!-- 操作按钮区域 -->
      <div class="table-operator" style="margin-bottom: 16px;">
        <a-button type="primary" icon="download" @click="handleAsyncExportXls()" :loading="exportLoading">
          {{ exportLoading ? '导出中...' : '导出' }}
        </a-button>
      </div>
      
      <a-table
          size="middle"
          :columns="columns"
          :dataSource="data"
          :pagination="pagination"
          :loading="loading"
          @change="handleTableChange"
          rowKey="id"
          bordered
          :scroll="{ x: 1500, y: 600 }"
      >
        <template slot="orderStatus" slot-scope="text">
          <a-tag :color="getStatusType(text)"> {{ getStatusText(text) }}</a-tag>
        </template>

        <template slot="paymentStatus" slot-scope="text">
          <a-tag :color="text === 1 ? 'green' : 'orange'">
            {{ text === 1 ? '已收款' : '未收款' }}
          </a-tag>
        </template>

        <template slot="action" slot-scope="text, record">
          <a-button type="link" size="small" @click="handleView(record)">
            查看
          </a-button>
        </template>
      </a-table>
    </a-card>

    <!-- 订单详情模态框 -->
    <order-detail-modal
        :visible="detailVisible"
        :orderId="currentOrderId"
        @close="handleDetailClose"
    />
  </div>
</template>

<script>
import {getCustomerOrderList, customerOrderStatistics} from '@/api/customer'
import OrderDetailModal from './modules/CustomerOrderDetail'
import {AsyncExportMixin} from '@/mixins/asyncExportMixin'
import {filterObj} from 'utils/util'

export default {
  mixins: [AsyncExportMixin],
  components: {
    OrderDetailModal
  },
  data() {
    return {
      queryParam: {},
      pagination: {
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ['10', '20', '30', '50'],
        showTotal: total => `共 ${total} 条`
      },
      loading: false,
      data: [],
      statistics: {
        payableTotal: 0,
        payTotal: 0,
        discountTotal: 0
      },
      // 导出相关配置
      url: {
        exportTaskUrl: 'ndt/export/task/customer/order/async',
        exportStatusUrl: "/ndt/export/task/status",
      },
      columns: [
        {
          title: '客户编码',
          dataIndex: 'customNo',
          align: 'center',
          fixed: 'left',
          width: 180
        },
        {
          title: '标签单号',
          dataIndex: 'equickWBNo',
          align: 'center',
          width: 180
        },
        {
          title: '运单号',
          dataIndex: 'lableNo',
          align: 'center',
          width: 180
        },
        {
          title: '订单状态',
          dataIndex: 'orderStatus',
          scopedSlots: {customRender: 'orderStatus'},
          align: 'center',
          width: 100
        },
        {
          title: '收款状态',
          dataIndex: 'paymentStatus',
          scopedSlots: {customRender: 'paymentStatus'},
          align: 'center',
          width: 100
        },
        {
          title: '下单时间',
          dataIndex: 'orderTime',
          align: 'center',
          width: 180
        },
        {
          title: '商品种类',
          dataIndex: 'goodsCategory',
          align: 'center',
          width: 180
        },
        {
          title: '计费重量（kg）',
          dataIndex: 'whtFatWht',
          align: 'center',
          width: 140
        },
        {
          title: '称重重量（kg）',
          dataIndex: 'whtWeightWht',
          align: 'center',
          width: 140
        },
        {
          title: '财务总费用（USD）',
          dataIndex: 'totalArPostage',
          align: 'center',
          width: 150
        },
        {
          title: '邮费（USD）',
          dataIndex: 'actuallyPostage',
          align: 'center',
          width: 120
        },
        {
          title: '其他费用（USD）',
          dataIndex: 'otherPostage',
          align: 'center',
          width: 140
        },
        {
          title: '应收金额（USD）',
          dataIndex: 'payableAmount',
          align: 'center',
          width: 140
        },
        {
          title: '实收金额（UZS）',
          dataIndex: 'payAmount',
          align: 'center',
          width: 140
        },
        {
          title: '积分优惠金额（UZS）',
          dataIndex: 'discountAmount',
          align: 'center',
          width: 140
        },
        {
          title: '操作',
          scopedSlots: {customRender: 'action'},
          width: 100,
          align: 'center',
          fixed: 'right'
        }
      ],
      
      detailVisible: false,
      currentOrderId: null
    }
  },
  mounted() {
    this.fetch()
    this.orderStatistics()
  },
  methods: {
    onDateChange: function (value, dateString) {
      console.log(dateString[0], dateString[1]);
      this.queryParam.orderStartTime = dateString[0];
      this.queryParam.orderEndTime = dateString[1];
    },
    onDateOk(value) {
      console.log(value);
    },
    fetch(params = {}) {
      this.loading = true
      const pagination = {...this.pagination}
      getCustomerOrderList({
        ...this.queryParam,
        current: pagination.current,
        size: pagination.pageSize,
        ...params
      }).then(response => {
        this.data = response.data.records || response.data
        pagination.total = response.data.total || response.data.length
        this.pagination = pagination
      }).finally(() => {
        this.loading = false
      })
    },
    orderStatistics() {
      customerOrderStatistics({
        ...this.queryParam
      }).then(response => {
        const data = response.data || {}
        this.statistics.payableTotal = data.totalPayableAmount
        this.statistics.payTotal = data.totalPayAmount
        this.statistics.discountTotal = data.totalDiscountAmount
      })
    },
    handleTableChange(pagination) {
      this.pagination = pagination
      this.fetch()
    },
    handleSearch() {
      this.pagination.current = 1
      this.fetch()
      this.orderStatistics()
    },
    handleReset() {
      this.queryParam = {}
      this.pagination.current = 1
      this.fetch()
      this.orderStatistics()
    },
    handleView(record) {
      this.currentOrderId = record.id
      this.detailVisible = true
    },
    handleDetailClose() {
      this.detailVisible = false
      this.currentOrderId = null
    },
    getStatusText(status) {
      const statusMap = {
        0: '运输中',
        1: '待取件',
        2: '已签收',
        3: '异常',
        4: '已取消'
      }
      return statusMap[status] || '未知状态'
    },
    getStatusType(status) {
      const typeMap = {
        0: 'orange',
        1: 'cyan',
        2: 'green',
        3: 'red',
        4: 'purple'
      }
      return typeMap[status] || 'default'
    },
    getQueryParams() {
      var param = Object.assign({}, this.queryParam);
      param.current = this.pagination.current;
      param.size = this.pagination.pageSize;
      return filterObj(param);
    }
  }
}
</script>

<style scoped>
.page-container {
  padding: 24px;
  background: #f0f2f5;
}

.search-card {
  margin-bottom: 16px;
}

.table-card {
  margin-bottom: 0;
}

.statistics-container {
  margin-bottom: 16px;
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  border-radius: 4px;
  padding: 12px 24px;
  width: 100%;
}

.statistics-content {
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
  align-items: center;
}

.statistic-item {
  display: flex;
  align-items: center;
  gap: 5px;
}

.statistic-label {
  color: #666;
}

.statistic-value {
  font-weight: 600;
  color: #2f54eb;
}

.statistic-unit {
  font-size: 0.8em;
  color: #666;
  margin-left: 2px;
}
</style>
